// =============================================
// SERVICIO DE NOTIFICACIONES
// =============================================

import api from './api';

const notificationService = {
  // Probar configuración de email
  testEmail: async (email) => {
    const response = await api.get('/notifications/test', { params: { email } });
    return response.data;
  },

  // Enviar recordatorios a morosos
  sendDebtReminders: async () => {
    const response = await api.post('/notifications/debt-reminder');
    return response.data;
  },

  // Enviar confirmación de pago
  sendPaymentConfirmation: async (paymentId) => {
    const response = await api.post(`/notifications/payment-confirmation/${paymentId}`);
    return response.data;
  },

  // Notificar nuevo período
  sendNewPeriodNotification: async (year, administratorName, ownerIds = []) => {
    const response = await api.post('/notifications/new-period', {
      year,
      administrator_name: administratorName,
      owner_ids: ownerIds
    });
    return response.data;
  },

  // Enviar estados de cuenta mensuales
  sendMonthlyStatements: async (month, year, ownerIds = []) => {
    const response = await api.post('/notifications/monthly-statement', {
      month,
      year,
      owner_ids: ownerIds // Agregar IDs de propietarios
    });
    return response.data;
  },
};

export default notificationService;
